import { Box, Grid, InputLabel, TextField, Tooltip, Typography } from '@mui/material'
import { inputLabelContainerStyle, inputLabelStyle, labelTooltipContainerStyle } from '../../CampaignSetup.styles'
import { Trans } from 'react-i18next'
import { t } from 'i18next'
import { Info } from 'react-feather'
import React from 'react'

interface OpeningHookSelectorProps {
	openingHooks: string[]
	value: string
	customValue: string
	typingOpeningHookInProgress?: boolean
	onChange: (event: any) => void
	setCustomOpeningHook: (event: any) => void
}

export default function OpeningHookCustomSelector({
	openingHooks,
	value,
	customValue,
	typingOpeningHookInProgress,
	onChange,
	setCustomOpeningHook,
}: OpeningHookSelectorProps) {
	return (
		<Grid item xs={12} sx={{ paddingTop: '16px!important' }}>
			<Box sx={labelTooltipContainerStyle}>
				<InputLabel shrink={false} htmlFor={'openingHook'} sx={inputLabelContainerStyle} required>
					<Typography sx={inputLabelStyle} variant="h5" component="span">
						<Trans i18nKey="run_campaign.opening_hook_label" />
					</Typography>
				</InputLabel>
				<Tooltip
					arrow
					placement="top"
					title={t('run_campaign.opening_hook_label_i')}
					sx={{ display: 'inline' }}
				>
					<Info style={{ width: '20px', height: '20px' }} />
				</Tooltip>
			</Box>
			<Box sx={{ width: '100%', height: '192px', overflowX: 'auto', overflowY: 'hidden' }}>
				<Grid
					container
					spacing={2}
					sx={{
						flexWrap: 'nowrap',
						pb: 2,
						height: '100%',
						width: 'max-content',
						'& .MuiGrid-item': {
							flexShrink: 0,
						},
					}}
				>
					{openingHooks?.map((hook: string, index: number) => (
						<Grid item xs={4} key={index}>
							<Box sx={{ width: '100%', height: '100%', padding: '4px' }} component="div">
								<TextField
									value={hook}
									variant="outlined"
									fullWidth
									InputProps={{
										style: {
											fontSize: '14px',
											whiteSpace: 'normal',
											wordWrap: 'break-word',
											width: '100%',
											height: '100%',
											overflow: 'auto',
											cursor: 'pointer',
										},
									}}
									multiline
									onClick={() => onChange({ target: { value: hook } })}
									sx={{
										backgroundColor:
											!typingOpeningHookInProgress && value === hook ? '#f5f5f5' : 'transparent',
										cursor: 'pointer',
										height: '100%',
										caretColor: 'transparent',
										transition: 'transform 0.2s ease-in-out', // Add smooth transition
										'&:hover': {
											transform: 'scale(1.02)', // Scale up by 5% on hover
										},
										'& .MuiInputBase-root': {
											height: '100%',
											cursor: 'pointer',
										},
										'& .MuiInputBase-input': {
											height: '100% !important',
											overflowY: 'auto !important',
											cursor: 'pointer',
										},
									}}
								/>
							</Box>
						</Grid>
					))}
					<Grid item xs={4} key={openingHooks.length}>
						<Box sx={{ width: '100%', height: '100%', padding: '4px' }} component="div">
							<TextField
								value={customValue === '' || !openingHooks.includes(customValue) ? customValue : ''}
								variant="outlined"
								fullWidth
								InputProps={{
									style: {
										fontSize: '14px',
										whiteSpace: 'normal',
										wordWrap: 'break-word',
										width: '100%',
										height: '100%',
										overflow: 'auto',
									},
								}}
								onChange={setCustomOpeningHook}
								onClick={() => onChange({ target: { value: customValue } })}
								multiline
								placeholder="Use your own opening hook!"
								sx={{
									// if value is customvalue and customValue not is empty or just one space
									backgroundColor:
										(value === customValue && customValue.trim() !== '') ||
										typingOpeningHookInProgress
											? '#f5f5f5'
											: 'transparent',
									cursor: 'pointer',
									height: '100%',
									transition: 'transform 0.2s ease-in-out', // Add smooth transition
									'&:hover': {
										transform: 'scale(1.05)', // Scale up by 5% on hover
									},
									'& .MuiInputBase-root': {
										height: '100%',
									},
									'& .MuiInputBase-input': {
										height: '100% !important',
										overflowY: 'auto !important',
									},
								}}
							/>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Grid>
	)
}
